(ns com.theplantscape.plant-web.monitoring
  (:require
   ["@sentry/react" :as Sentry]
   ["@sentry/tracing" :refer [BrowserTracing]]
   ["logrocket" :refer [LogRocket] :as logrocket]))

(defn monitor-start []
  (.init logrocket "dmqwol/theplantery"))

(defn monitor-user [user]
  (.identify logrocket (:user-id user) user))
